import Vue from 'vue';
import VueRouter from 'vue-router';
import firebase from 'firebase/app';
import 'firebase/auth';
import Home from '../views/Home.vue';


Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            // return to.hash;
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: () => import(/* webpackChunkName: "Login" */ '@/components/login/Login.vue'),
        },
        {
            path: '/pricing',
            name: 'Pricing',
            component: () => import(/* webpackChunkName: "Pricing" */ '@/views/Pricing.vue'),
        },
        // {
        //     path: '/signup',
        //     name: 'SignUp',
        //     component: import(/* webpackChunkName: "Signup" */ '@/components/login/Signup.vue'),
        // },
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        {
            path: '/payments',
            name: 'Payments',
            component: () => import(/* webpackChunkName: "Payments" */ '../views/Payments.vue'),
            meta: {
                requiresAuth: true,
            },

        },
        {
            path: '/termsOfUse',
            name: 'TermsOfUse',
            component: () => import(/* webpackChunkName: "TermsOfUse" */ '../views/legal/TermsOfUse.vue'),
        },
        {
            path: '/imprint',
            name: 'Imprint',
            component: () => import(/* webpackChunkName: "Imprint" */ '../views/legal/Imprint.vue'),
        },
        {
            path: '/privacy',
            name: 'Privacy',
            component: () => import(/* webpackChunkName: "Privacy" */ '../views/legal/Privacy.vue'),
        },
    ],

});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const { currentUser } = firebase.auth();
        // console.log('routerUser', currentUser);
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!currentUser) {
            next({
                name: 'Login',
                // query: { redirect: to.fullPath },
            });
        } else {
            next();
        }
    } else {
        next(); // make sure to always call next()!
    }
});

export default router;
